import Tippy from '@tippyjs/react';
import styled from 'styled-components';

function NotDemoProjectIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16"
        >
            <path
                color="rgb(255, 147, 69)"
                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
            />
        </svg>
    );
}

function DemoProjectIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16"
        >
            <path
                color="rgb(130, 240, 130)"
                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
            />
            <path
                color="rgb(60, 220, 60)"
                d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"
            />
        </svg>
    );
}

function NotFilteredCheckboxIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16"
        >
            <path
                color="rgb(200, 200, 200)"
                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
            />
            <path
                color="rgb(200, 200, 200)"
                d="M11.354 4.646a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708 0z"
            />
        </svg>
    );
}

export enum DemoProjectFilterValue {
    Unset = 1,
    DemoProject = 2,
    NotDemoProject = 3
}

const FilterContainer = styled.span`
    display: inline-block;
    height: 18px;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
`;

export function DemoProjectFilter({
    value,
    onChange
}: {
    value: DemoProjectFilterValue;
    onChange: ({value}: {value: DemoProjectFilterValue}) => void;
}) {
    function message() {
        switch (value) {
            case DemoProjectFilterValue.Unset:
                return 'Showing demo and non-demo projects';
            case DemoProjectFilterValue.DemoProject:
                return 'Showing demo projects';
            case DemoProjectFilterValue.NotDemoProject:
                return 'Showing non-demo projects';
            default:
                return null;
        }
    }

    function icon() {
        switch (value) {
            case DemoProjectFilterValue.Unset:
                return <NotFilteredCheckboxIcon />;
            case DemoProjectFilterValue.DemoProject:
                return <DemoProjectIcon />;
            case DemoProjectFilterValue.NotDemoProject:
                return <NotDemoProjectIcon />;
            default:
                return null;
        }
    }

    function nextValue() {
        switch (value) {
            case DemoProjectFilterValue.Unset:
                return DemoProjectFilterValue.DemoProject;
            case DemoProjectFilterValue.DemoProject:
                return DemoProjectFilterValue.NotDemoProject;
            case DemoProjectFilterValue.NotDemoProject:
                return DemoProjectFilterValue.Unset;
            default:
                return null;
        }
    }

    return (
        <Tippy content={message()}>
            <FilterContainer onClick={() => onChange({value: nextValue()})}>
                {icon()}
            </FilterContainer>
        </Tippy>
    );
}